export default "__VITE_ASSET__C6ELvX4M__"